import 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { styled } from '../../theme/utils.js';
import '../../theme/types.js';

const Wrapper = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});
const StyledImage = styled("img", ({ $loaded, $theme }) => ({
  opacity: $loaded ? 1 : 0,
  transition: `${$theme.animation.duration["300"]} opacity ${$theme.animation.timingFn.ease}`
}));

export { StyledImage, Wrapper };
